import React, { useState, useRef, useEffect} from "react";
import "./VideoCard.css"; // 引入 CSS 样式

const VideoCard = ({ videoSrc, coverSrc }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);

    const handlePlay = () => {
        setIsPlaying(true);
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleVideoEnd = () => {
        setIsPlaying(false);
    };
    

    useEffect(() => {
        const handleFullScreenChange = () => {
            if (document.fullscreenElement === videoRef.current) {
                videoRef.current.style.objectFit = "contain"; // 全屏时完整显示
            } else {
                videoRef.current.style.objectFit = "cover"; // 退出全屏恢复原样
            }
        };

        document.addEventListener("fullscreenchange", handleFullScreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullScreenChange);
        };
    }, []);

    return (
        <div className="video-card">
            {/* 封面层 */}
            {!isPlaying && (
                <div className="video-cover" onClick={handlePlay}>
                    <img src={coverSrc} alt="视频封面" className="cover-img" />
                    <div className="play-button">
                        <svg width="50" height="50" viewBox="0 0 24 24" fill="white">
                            <path d="M8 5v14l11-7z" />
                        </svg>
                    </div>
                    <div className="videobanner">视频讲解</div>
                </div>
            )}

            {/* 视频播放器 */}
            <video
                ref={videoRef}
                className={`video-player ${isPlaying ? "show" : ""}`}
                src={videoSrc}
                controls
                onEnded={handleVideoEnd}
            />
        </div>
    );
};

export default VideoCard;
